import { PayPalButtonOnClick } from "@paypal/paypal-js"
import { getCart } from "src/checkout/hooks/useCart"
import { setExpressCheckoutActive, setExpressCheckoutErrorMessage } from "src/checkout/state/checkoutExpressStore"
import { paypalLogPrefix } from "src/integrations/paypal/constants"
import { trackBeginCheckout } from "src/tracking/events"

export const payPalButtonOnClick: PayPalButtonOnClick = async (data, actions) => {
  console.debug(paypalLogPrefix, "onClick", data, actions)
  setExpressCheckoutErrorMessage(null)
  setExpressCheckoutActive(true)
  trackBeginCheckout(getCart()!)
}
